import script from "./WhatsappBusinessAccountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsappBusinessAccountView.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsappBusinessAccountView.vue?vue&type=style&index=0&id=edfb0c16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edfb0c16"]])

export default __exports__